<template>
	<div>
		<ts-loading-banner :loading="loading">
			<div class="ts-flex ts-jus">
				<div class="ts-relative ts-w-full">
					<input 
						v-model.trim="search"
						ref="search"
						type="text" class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
						:placeholder="$t('wholesale.searchProductList')"
					>
					<span class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2" style="margin-top: 7px"><i class="fa fa-search"></i></span>
				</div>
			</div>
			<br>
			<div class="max-h ts-px-3">
				<table class="ts-w-full">
					<thead>
						<tr>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" >{{$t('wholesale.productGroup') }}</th>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" >{{$t('wholesale.barcode') }}</th>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" >{{$t('wholesale.productName') }}</th>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center" >{{$t('wholesale.qtyInStock') }}</th>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center" >{{$t('wholesale.qty') }}</th>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" >{{ $t('actions') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr 
						class="ts-border-b ts-border-gray-300"
						v-for="(product, index) in productList"
						:key="index"
					>
						<td class="ts-text-xs">{{ product.pro_group_name_en }}</td>
						<td class="ts-text-xs">{{ product.barcode }}</td>
						<td class="ts-text-xs">{{ product.product_name_en }}</td>
						<td class="ts-text-xs ts-px-2 ts-text-right ts-w-8">{{ product.ending_balance }}</td>
						<td class="ts-text-center">
							<input 
								v-model="product.quantity"
								type="number" placeholder="qty" 
								class="ts-w-16 ts-outline-none ts-border-t ts-px-2 ts-py-1 ts-rounded ts-mt-2 ts-text-xs ts-text-center"
								@keypress.enter="addItem(product)"
							>
						</td>
						<td style="width:1%" class="text-center ts-pl-4">
							<a href="#"
								v-tooltip="$t('add')"
								@click.prevent="addItem(product)"
								class="ts-mb-0"
							>
								<i class="fa fa-plus"></i>
							</a>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</ts-loading-banner>
	</div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
	name: 'productList',
	props: ['value'],
	data(){
		return {
			search: '',
			loading: false,
			products: [],
			model: {}
		}
	},
	created() {
    this.model = this.value
		this.fetchProduct()
		this.$nextTick(() => {
			this.$refs.search.focus();
		});
  },
	computed: {
    ...mapGetters('wholesale/operation', [
      'isDefaultUom',
      'getSalePrice',
			'getDiscount',
			'getFreeItemBuyItem'
    ]),
		productList() {
      return this.products.filter(p => !_.includes(this.model.product_detail.map(el => el.product_id),p.product_id))
    },
	},
	methods: {
		...mapActions('wholesale/operation', ['getProduct']),
		addItem(product) {
			this.$store.commit('wholesale/operation/SET_PRODUCT', product)
			var uom_id = this.isDefaultUom(product.product_id)
			 this.model.product_detail.push({
				product_id: product.product_id,
				product_name_en: product.product_name_en,
				barcode: product.barcode,
				uom_id: uom_id,
				quantity: product.quantity ? product.quantity : 1,
				unit_price: this.getSalePrice({ product_id: product.product_id, uom_id: uom_id }),
				discount_type: '%',
				discount_rate: this.getDiscount({ product_id: product.product_id, uom_id: uom_id }),
				discount_amount: 0,
				total_after_discount: 0,
				vat_rate: 0,
				vat_amount: 0,
				grand_total: 0,
				promo_ref_promo_product_id: null,
				promo_type_id: null,
				serial_list: [],
				is_custom: false,
				has_serial: product.is_generate_unique_serial
			})
			this.$emit('calculate')
		},
    fetchProduct(){
      this.loading = true
      this.products = []
      this.getProduct({ filter: {
        search: this.search
      }})
        .then(response => {
          this.products = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
	},
	watch: {
    search: debounce(function (search) {
      this.fetchProduct()
    }, 500),
  }
}
</script>

<style scoped>
.max-h {
  height: 240px;
  max-height: 250px;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  border-spacing: 0;
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
</style>